<template lang="pug">
  .address-update-subs-modal.dashboard-inner.narrow-modal-body
    SectionTitle(text="Update Address").app-modal-title
    p.xs-f-small.max-at-tweak You've updated your default shipping address. Would you like to use this address for all subscriptions?
    .row(v-for="sub in subsToUpdate" :key="sub.id")
      .row.prod
        .xs-12.prod-info
          p.upper.bold &#183;  {{ sub.products[0].product_name }}
          Pill(v-if="sub.has_extra_tube" text="Extra Tube").ml-10.inline-block

    SubmitButtons(
      submit-text="use this address"
      :submit-method="onSubmit"
      cancel-text="no, don't update my other subscriptions"
      :cancel-method="cancel"
      :cancel-link="true"
    )
  
</template>

<script>
  import { mapState, mapMutations, mapActions } from 'vuex';
  import SubmitButtons from "../SubmitButtons";
  import SectionTitle from "../SectionTitle";
  import Pill from "../Pill";
  export default {
    name: "AddressUpdateSubsModal",
    components: {
      Pill,
      SectionTitle,
      SubmitButtons
    },

    computed: {
      ...mapState('addressBook', [
        'editAddressForm',
        'lastSavedAddress'
      ]),

      ...mapState('subscriptions', [
        'subsToUpdate'
      ])
    },

    methods: {
      ...mapMutations('addressBook', [
        'setSavingAddress'
      ]),

      ...mapActions('addressBook', [
        'updateShipAddressForSubscriptions',
        'updateLastSavedAddress'
      ]),

      ...mapActions('subscriptions', [
        'loadCustomerSubs'
      ]),

      ...mapActions('modal', ['hideModal']),

      onSubmit() {
        let payload = {
          subIds: this.subsToUpdate.map(sub => sub.id),
          newAddressId: this.lastSavedAddress.id
        };

        this.setSavingAddress(true);
        return this.updateShipAddressForSubscriptions(payload)
          .then(() => {
            this.updateLastSavedAddress({});
            this.loadCustomerSubs();
            this.hideModal();
          })
          .finally(() => {
            this.setSavingAddress(false);
          });
      },

      cancel() {
        this.hideModal();
        this.updateLastSavedAddress({});
      }
    }
  }
</script>

<style scoped lang="stylus">
  .address-update-subs-modal
    > p
      padding-bottom 1em

    .prod
      padding-bottom 1em

    .prod-info
      padding-left 0.5em

      p
        padding-bottom 0.5em

</style>